export default {
  getProjectSectorLabel: ({ projectSectorMap }, { currentLang }) => sector => projectSectorMap[sector][currentLang],

  currentLang: ({ route }) => {
    const { meta = {} } = route
    return meta.lang || ''
  },

  overlayLink: ({ route }) => (overlay, additionalQuery = {}) => {
    const { hash, query = {}, ...currentRoute } = route
    const { overlay: currentOverlay, ...currentQuery } = query

    return overlay === currentOverlay
      ? { ...currentRoute, ...currentQuery }
      : { ...currentRoute, query: { ...currentQuery, overlay, ...additionalQuery } }
  },

  articlesBySlug: ({ collections = {} }) => {
    const { articles = {} } = collections
    return Object.values(articles).reduce(
      (articleSlugMap, article) => ({ ...articleSlugMap, [article.slug]: article }),
      {}
    )
  },

  currentNewsCategories: ({ taxonomies }, { currentLang }) => {
    const { newsCategories = { [currentLang]: {} } } = taxonomies
    return newsCategories[currentLang]
  },

  newsFilterSlugMap: (state, { currentNewsCategories }) => {
    return Object.values(currentNewsCategories).reduce(
      (categorySlugMap, { slug, id }) =>
        Object.values(slug).reduce((slugMap, filter) => ({ ...slugMap, [filter]: id }), categorySlugMap),
      {}
    )
  }
}
